<p-table [value]="[0, 1, 2, 3, 4, 5]" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr class="tw-text-sm">
      <th>ID</th>
      <th>Nome</th>
      <th>Status</th>
      <th>Data de criação</th>
      <th>Data de alteração</th>
      <th>Detalhes</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-number>
    <tr>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>
